<script lang="ts">
	import { type Snippet } from 'svelte'

	interface Props {
		level?: string
		tagName?: string
		children?: Snippet
	}

	let { level = '1', tagName = null, children }: Props = $props()

	const classes = {
		'1': 'font-display text-2xl font-bold text-black dark:text-white lg:text-2xl',
		'2': 'text-black dark:text-white font-display text-xl lg:text-2xl font-extrabold',
		'3': 'text-black dark:text-white font-semibold',
		special: 'text-gray-600 dark:text-gray-200 uppercase text-gray-600',
	}
</script>

<svelte:element this={tagName || level === 'special' ? 'h3' : `h${level}`} class={classes[level]}>
	{@render children?.()}
</svelte:element>
